import State from '../core/State';
import ProductPricing from '../entity/ProductPricing';

export const setProductPricing = (productPricing: ProductPricing) => (state: State): State => ({
  ...state,
  acct: {
    ...state.acct,
    productPricing,
  },
});
